import Bribery from 'views/Bribery'

const BriberyPage = () => {
  return <Bribery />
}

BriberyPage.Layout = BriberyPage
// BriberyPage.mp = false

export default BriberyPage
